import { createEntityAdapter, createReducer } from '@reduxjs/toolkit';
import { BearerboxModel } from '../../models/bearerboxModel';
import { BearerboxStateModel } from './bearerboxStateModel';
import {
  bearerboxFetchFailureAction
, bearerboxFetchRequestAction
, bearerboxFetchSuccessAction
} from './bearerboxActions';

export const bearerboxAdapter = createEntityAdapter<BearerboxModel>({
  selectId: bearerbox => bearerbox.serverId,
});

const initialState: BearerboxStateModel = bearerboxAdapter.getInitialState({
  fetchingStatus: {},
});

export const initialBearerboxFetchingStatus = {
  loading: false,
  errors: [],
};

export const bearerboxReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(bearerboxFetchRequestAction, (state, action) => {
      state.fetchingStatus = {
        ...state.fetchingStatus,
        [action.payload.serverId]: {
          loading: true,
          errors: [],
        },
      };
    })
    .addCase(bearerboxFetchSuccessAction, (state, action) => {
      const oldFetchingState = state.fetchingStatus[action.payload.serverId];

      state.fetchingStatus = {
        ...state.fetchingStatus,
        [action.payload.serverId]: {
          ...oldFetchingState,
          loading: false,
        },
      };

      bearerboxAdapter.setOne(state, action.payload);
    })
    .addCase(bearerboxFetchFailureAction, (state, action) => {
      const oldFetchingState = state.fetchingStatus[action.payload.serverId];

      state.fetchingStatus = {
        ...state.fetchingStatus,
        [action.payload.serverId]: {
          loading: false,
          errors: [
            ...oldFetchingState.errors,
            action.payload.error,
          ],
        },
      };
    });
});
